import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import api from '../services/api';
import { getSwalTheme } from '../utils/swalTheme';
import { DRIVE_TYPES } from '../constants/vehicles';
import './PostShiftPage.css';

const PostAvailabilityPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    vehicle_type: '',
    drive_type: '',
    wav: false,
    shift_type: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const submitData = {
        title: formData.title,
        description: formData.description,
        vehicle_types: formData.vehicle_type ? [formData.vehicle_type] : [],
        drive_type: formData.drive_type || null,
        wav: formData.wav,
        shift_type: formData.shift_type,
      };

      await api.post('/driver-posts', submitData);
      await Swal.fire({
        ...getSwalTheme(),
        icon: 'success',
        title: 'Driver Listing Posted!',
        text: 'Vehicle owners can now see your listing.'
      });
      navigate('/dashboard');
    } catch (err) {
      Swal.fire({
        ...getSwalTheme(),
        icon: 'error',
        title: 'Post Failed',
        text: err.response?.data?.error || 'Failed to create listing'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="post-shift-page">
      <div className="post-shift-container">
        <h1>Driver Listing</h1>
        <p className="subtitle">Let vehicle owners know you're available</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="post-shift-form">
          <div className="form-group">
            <label htmlFor="title">Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="e.g., Licensed driver looking for weekly day shift"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="e.g., 5 years experience, clean driving record, available immediately..."
              rows={2}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="vehicle_type">Work Type</label>
              <select
                id="vehicle_type"
                name="vehicle_type"
                value={formData.vehicle_type}
                onChange={handleChange}
              >
                <option value="">Any / Flexible</option>
                <option value="yellow_cab">Yellow Cab</option>
                <option value="green_boro">Green Boro</option>
                <option value="black_car">Black Car</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="drive_type">Drive Type</label>
              <select
                id="drive_type"
                name="drive_type"
                value={formData.drive_type}
                onChange={handleChange}
              >
                <option value="">Any / Flexible</option>
                {DRIVE_TYPES.map(dt => (
                  <option key={dt.value} value={dt.value}>{dt.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <div className="checkbox-group" style={{ display: 'flex' }}>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="wav"
                  checked={formData.wav}
                  onChange={handleCheckboxChange}
                />
                WAV
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="shift_type">Shift Type *</label>
            <select
              id="shift_type"
              name="shift_type"
              value={formData.shift_type}
              onChange={handleChange}
              required
            >
              <option value="">Select shift type</option>
              <option value="dov">DOV (Drive Own Vehicle)</option>
              <option value="weekly_24">Weekly 24hr</option>
              <option value="weekly_day">Weekly Day</option>
              <option value="weekly_night">Weekly Night</option>
              <option value="daily_day">Daily Day</option>
              <option value="daily_night">Daily Night</option>
              <option value="daily_24">Daily 24hr</option>
            </select>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/dashboard')}
            >
              Cancel
            </button>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Posting...' : 'Post Driver Listing'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostAvailabilityPage;
